define('view/controller/booking/details/DetailsView',['require','marionette','lib/view/ModalRegion','view/controller/booking/details/DetailsLicenseView','view/controller/booking/details/DetailsInfoView','Config','lib/Utils','lib/view/mixin/IntlPhone','view/controller/booking/details/BookingLeaveConfirmationView'],function (require) {

	var Marionette = require('marionette');
    var ModalRegion = require('lib/view/ModalRegion');
    var DetailsLicenseView = require('view/controller/booking/details/DetailsLicenseView');
    var DetailsInfoView = require('view/controller/booking/details/DetailsInfoView');
	var Config = require('Config');
	var Utils = require('lib/Utils');
	var IntlPhone = require('lib/view/mixin/IntlPhone');
	var BookingLeaveConfirmationView = require('view/controller/booking/details/BookingLeaveConfirmationView');

	/**
	 * Client info form view
	 * 
	 * @class DetailsView
	 */
	return Marionette.LayoutView.extend({
	
	    template: '#details_info_view',
	    ui: {
	    	inputs: '#sb_client_info_container :input',
			is_pay_full_price_without_deposit: '#is_pay_full_price_without_deposit_container',
			bookBtn: '#sb_book_btn',
			//licenseBtn: '#sb_license_container a',
			clientInfoForm: '#sb_client_info_container',
			phoneInput : '#sb_client_info_container :input[name=client_phone]',
			packageLinkBlock: '.sb-package-link-block',
			confirmLink: '.sb-confirm-leave a'
	    },
	    modelEvents: {
	    	'invalid': 'render'
	    },
	    events: {
	    	'change @ui.inputs': 'setModelData',
	    	'change @ui.is_pay_full_price_without_deposit': 'setIsPayFullPriceWithoutDeposit',
            'click @ui.bookBtn': 'submitBooking',
			'click @ui.confirmLink': 'confirmLinkClick'
	    },
		regions: {
	    	'info': '#sb_booking_info',
			'terms': '#sb_terms_and_conditions'
		},
        _licenseModel: null,
        _timeValidateModel: null,

        /**
         * Initialize view
         */
        initialize: function () {
            this._licenseModel = this.getOption('licenseModel');
			this._timeValidateModel = this.getOption('timeValidateModel');
        },

        /**
		 * Submit booking to server
         */
        submitBooking: function () {
			this.ui.bookBtn.prop('disabled', true).addClass('disabled');
			this.triggerMethod('submit');
		},

	    /**
	     * Called when user changes the data 
	     * Sets data to model
	     * 
	     * @param Event event
	     */
	    setModelData: function (event) {
	    	var element = jQuery(event.target);

			var value = element.val();
			if (element.attr('name') === 'client_phone') {
				value = Utils.getClientPhoneValue(value);
			}

	    	this.model.set(element.attr('name'), value);
	    },

		setIsPayFullPriceWithoutDeposit: function(event) {
			var el = $(event.target);
			this.model.set(el.attr('name'), el.is(':checked'));
		},

        showTermsAndConditions: function (view) {
	    	this.terms.show(view);
		},

	    /**
	     * Serialize data to display on view
	     * 
	     * @return Object
	     */
	    serializeData: function () {
	        var errors = this.model.validationError || {};
            if (!errors.global_form) {
                errors.global_form = this._timeValidateModel.get('error');
            }
	    	var data = _.extend(Marionette.LayoutView.prototype.serializeData.call(this), {
	    		'errors': errors,
                'recurring_dates': this._timeValidateModel.get('dates')
	    	});
			if (data.batch_model && _.isEmpty(this.model.validationError)) {
				data.client_info_readonly = true;
			}

            //_.extend(data, Utils.getClientPhoneData(data.client_phone));
			_.extend(data, {
				'client_phone': Utils.getClientPhoneValue(
					data.client_phone
				)
			});

			data.time_diff = this.getOption('clientTimeZone').get('time_diff');
			data.server_address = Config.getInstance().getOption('server_address');
			data.project_name = Config.getInstance().getOption('project_name');

	    	return data;
	    },

		onRender: function () {
	    	this.showChildView('info', new DetailsInfoView({
				model: this.model,
                clientTimeZone: this.getOption('clientTimeZone'),
				timeValidateModel: this._timeValidateModel,
				timeCorrectionModel: this.getOption('timeCorrectionModel')
			}));

			var config = Config.getInstance();

			IntlPhone.showIntlPhone(this.ui.phoneInput, {
				//required : false,
				nationalMode: true,
				countryPrefix: config.getOption('country_prefix'),
				countryPrefixId: config.getOption('country_prefix_id'),
				allowedPrefix: config.getOption('country_prefix_is_changeable')?null:config.getOption('country_prefix'),
			});
		},

		onDomRefresh: function () {
            var errors = this.model.validationError || {};
            if (errors.global_form) {
                Backbone.Wreqr.radio.vent.trigger('status_message', 'shown');
            } else if (errors && !_.isEmpty(errors)) {
                Backbone.Wreqr.radio.vent.trigger('field_error', 'shown', {
                    'type': 'client_details'
                });
            }
		},

		hidePackageLinkBlock: function () {
			this.ui.packageLinkBlock.hide();
		},

		confirmLinkClick: function (evt) {
            evt.preventDefault();
            
            var $target = $(evt.currentTarget);
            var link = $target.attr('href');
            
            var region = new ModalRegion();
            var view = new BookingLeaveConfirmationView();
            region.show(view);

            this.listenTo(view, 'confirm', function () {
                window.location = link;
            });
        }
	
	});
	
});
